import React from 'react'
import Form from '../Form'
import Ponnu from "./ponnu.jpg"
export default function Banner1(data) {
  console.log(data,"banner")
  // console.log(data.data.bannerHeading,"esdesd")
  return (
    <section className="banner-area-6">
    <div className="container">
      <div className="row ">
        <div className="col-lg-7">
          <div className="banner-content wow fadeInRight" data-wow-delay="0.2s">
          <h1>{data?.data?.bannerHeading}
            </h1>
            <p>{data?.data?.bannerSubHeading}</p>
            <div className="d-flex flex-column flex-sm-row mt-25 subscribe-field">
              <input type="email" className="form-control me-sm-1" placeholder="Enter mobile Number" />
              <a href="#" className="input-append theme-btn theme-btn-lg ms-sm-2">Get Started</a>
            </div>
            <ul className="list-unstyled feature-list">
              <li><i className="fas fa-check-circle" /> Get Free Consulatation</li>
              <li><i className="fas fa-check-circle" /> No Spamming</li>
            </ul>
          </div>
        </div>
        <div className="col-lg-5 text-center text-lg-start">
          <div className="banner-img">
            <img className="img-1 wow fadeInLeft" data-wow-delay="0.3s" src={Ponnu} alt="" />
            <img className="img-3 wow fadeInRight" data-wow-delay="1.1s" src="img/home-5/banner-img-3.png" alt="" />
            <img className="img-shape" src="img/home-5/banner-shape.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}
